/* ===========================================================================
   AIRFORMANCE X — Cuenta atras de la campana de octubre (cajon del carrito)
   ---------------------------------------------------------------------------
   POR QUE VIVE AQUI Y NO DENTRO DEL SNIPPET

   El cajon del carrito solo se renderiza en servidor con el carrito LLENO.
   Si el cliente llega con el carrito vacio y anade su primer producto, el
   tema re-renderiza la region <xo-cart-will-change> inyectando HTML. Los
   <script> que llegan por innerHTML NO se ejecutan nunca (lo prohibe la
   especificacion de HTML), asi que un contador escrito dentro del snippet
   se quedaba en "-- d -- h -- min" exactamente en el caso mas comun:
   la primera compra de la sesion.

   Este fichero lo carga layout/theme.liquid en TODAS las paginas, asi que el
   reloj ya esta corriendo antes de que exista el cajon.

   SE AUTORREPARA: no guarda referencias a los nodos. El tema sustituye el
   <xo-cart-mini> entero al refrescar, de modo que cualquier nodo guardado
   queda huerfano y se seguiria pintando sobre un elemento que ya no esta en
   la pagina. Por eso se vuelve a buscar en cada pasada.

   LA FECHA MANDA DESDE LIQUID: el snippet escribe data-afx-cend con la marca
   de tiempo Unix del final de campana. Para cambiar la campana se edita el
   snippet, nunca este fichero.
   =========================================================================== */
(function () {
  'use strict';

  // Un solo reloj por pagina, pase lo que pase con el cajon.
  if (window.__AFX_CEND_V2) { return; }
  window.__AFX_CEND_V2 = true;

  var INTERVALO = 30000;   // minutos, no segundos: no hace falta mas
  var tempo = null;

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function pinta() {
    var caja = document.querySelector('[data-afx-cend]');
    if (!caja) { return; }   // cajon cerrado o carrito vacio: nada que hacer

    var fin = parseInt(caja.getAttribute('data-afx-cend'), 10) * 1000;
    if (!fin) { return; }

    var resta = fin - Date.now();
    if (resta <= 0) {
      // Campana terminada: se oculta sola, sin dejar un cero colgando.
      caja.style.display = 'none';
      if (tempo) { clearInterval(tempo); tempo = null; }
      return;
    }

    var s = Math.floor(resta / 1000);
    var d = caja.querySelector('[data-d]');
    var h = caja.querySelector('[data-h]');
    var m = caja.querySelector('[data-m]');

    if (d) { d.textContent = Math.floor(s / 86400); }
    if (h) { h.textContent = pad(Math.floor((s % 86400) / 3600)); }
    if (m) { m.textContent = pad(Math.floor((s % 3600) / 60)); }
  }

  function arranca() {
    pinta();
    if (!tempo) { tempo = setInterval(pinta, INTERVALO); }

    // Cada vez que el tema reescribe el cajon aparecen nodos nuevos con los
    // guiones por defecto. Repintamos en cuanto pasa, sin esperar al minuto.
    //
    // Con freno: en estas paginas el DOM no para quieto (carruseles, video,
    // apps), y repintar en cada mutacion es trabajo tirado. Como mucho dos
    // veces por segundo, que para un reloj de minutos sobra de largo.
    if ('MutationObserver' in window) {
      var pendiente = null;
      new MutationObserver(function () {
        if (pendiente) { return; }
        pendiente = setTimeout(function () { pendiente = null; pinta(); }, 500);
      }).observe(document.body, { subtree: true, childList: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arranca, { once: true });
  } else {
    arranca();
  }
})();
